<template>
  <div class="mu-modal">
    <div class="mu-modal__w">
      <div class="mu-modal__bd">
        <span v-html="warningText"></span>
        <div class="mu-modal__buttons">
          <button class="mu-modal__button" @click="$emit('hide-modal')">{{ cancelButtonText }}</button>
          <a class="mu-modal__button" :href="link">{{ continueButtonText }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    link: { type: String, required: true },
    warningText: {
      type: String,
      required: false,
      default: '<p><strong>Warning:</strong> The following content contains graphical material. Viewer discretion is advised.</p>'
    }
  },
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      buttonText: {
        continue: {
          en: 'Continue',
          fr: 'Continuer'
        },
        cancel: {
          en: 'Go Back',
          fr: 'Retourner'
        }
      }
    };
  },
  computed: {
    continueButtonText() {
      return this.buttonText.continue[this.curLang];
    },
    cancelButtonText() {
      return this.buttonText.cancel[this.curLang];
    }
  }
};
</script>